import React, {Component} from 'react';
import PropTypes from 'prop-types';
import StageDisplay from './stage-display';
import Size from './size';
import LayerList from './layer-list';
import './stage-editor.css';

/** @class StageEditor
 * A StageEditor component enables a user to modify
 * a stage corresponding to a specific location in
 * an expo.
 * @prop {string} dataURL - the url to the stage
 * @prop {number} width - the width of the stage
 * @prop {number} height - the height of the stage
 * @prop {object} layers - the stage's layers
 * @prop {object} icons (optional) - icons to display on stage
 */
export default class StageEditor extends Component {
  render() {
    return (
      <div>
        <div className="stage-editor">
          <div className="sidebar">
            <Size dataURL={this.props.dataURL} width={this.props.width} height={this.props.height} />
            <LayerList dataURL={this.props.dataURL + '/layers'}/>
          </div>
          <div className="stage">
            <StageDisplay {...this.props} />
          </div>
        </div>
      </div>
    )
  }
}

StageEditor.propTypes = {
  dataURL: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  layers: PropTypes.object.isRequired,
  icons: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/stage-editor/stage-editor.js